import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_get_map_filtersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { datex_order_info?: $frontendTypes.FootprintEdi.DatexOrderInfo, datex_adjustment_info?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo, datex_inventory_info?: $frontendTypes.FootprintEdi.DatexInventoryInfo, transaction_type: string }): Promise<{ map_filters?: any, skip?: boolean, integration_id?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.transaction_type)) {
      $missingRequiredInParams.push('\'transaction_type\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

